import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback, useMemo } from 'react';
import { MenuButton } from '../../../Finance2/common-grid-defs/MenuButton';
import { useDealActions2 } from '../../hooks/useDealActions';
import {
  isOpenDrawerState,
  selectedDealActionAtom,
  selectedDealState,
  useShowNearestDealOrClose,
} from '../../state/DealboardUIStateJ';
import { useDealAuditMenuItem } from './DealAudit';

export function TrackedDealMenu() {
  const showNearestDealOrClose = useShowNearestDealOrClose();
  const { handleMoveToCurrent } = useDealActions2();
  const setSelectedDealAction = useSetAtom(selectedDealActionAtom);
  const setIsOpenDrawer = useSetAtom(isOpenDrawerState);
  const deal = useAtomValue(selectedDealState);
  const dealAuditMenuItem = useDealAuditMenuItem();

  const onMoveToCurrent = useCallback(() => {
    if (!deal) {
      return;
    }
    handleMoveToCurrent(deal);
    setIsOpenDrawer(false);
  }, [deal, handleMoveToCurrent, setIsOpenDrawer]);

  const items = useMemo(() => {
    if (!deal) {
      return [];
    }
    return [
      {
        name: 'Move to Current',
        icon: <GpsFixedIcon />,
        onClick: onMoveToCurrent,
      },
      {
        name: 'Move to Passed',
        icon: <ThumbDownAltOutlinedIcon />,
        onClick: () =>
          setSelectedDealAction({
            action: 'pass',
            dealId: deal.id,
            next: () => setIsOpenDrawer(false),
          }),
      },
      {
        name: 'Delete Deal',
        icon: <DeleteOutlineIcon />,
        onClick: () =>
          setSelectedDealAction({
            action: 'delete',
            dealId: deal.id,
            next: () => showNearestDealOrClose(deal),
          }),
        divider: true,
      },
      dealAuditMenuItem,
    ];
  }, [
    deal,
    dealAuditMenuItem,
    onMoveToCurrent,
    setIsOpenDrawer,
    setSelectedDealAction,
    showNearestDealOrClose,
  ]);

  if (!deal) {
    return null;
  }

  return <MenuButton menuItems={items} />;
}
